// 存储数据时，存入过期时间戳expire
// @param {string} key 存储的键
// @param {any} value 存储的值
// @param {number} exdays 存储天数，未传入视为永久存储
export function setLocal(key, value, exdays) {
    const expire = exdays? exdays * 24 * 60 * 60 * 1000 : 0; // 天数转毫秒
    const storageData = {
        value,
        expire: exdays? Date.now() + expire : null // 当前时间 + 存储时限 = 到期时间戳
    };
    try {
        window.localStorage.setItem(key, JSON.stringify(storageData));
    } catch (error) {
        console.error(`存储 ${key} 的本地存储数据时出错:`, error);
    }
}

// 获取数据时检查是否过期，已过期就删除
// @param {string} key 存储的键
export function getLocal(key) {
    try {
        const localStorageItem = JSON.parse(window.localStorage.getItem(key));
        if (!localStorageItem) return null; // 不存在则返回null
        if (!localStorageItem.expire) return localStorageItem.value; // 无过期时间则返回数据
        if (Date.now() > localStorageItem.expire) {
            window.localStorage.removeItem(key);
            return null; // 已过期返回null并删除相应的缓存
        }
        return localStorageItem.value; // 在有效期内返回数据
    } catch (error) {
        console.error(`解析 ${key} 的本地存储数据时出错:`, error);
        window.localStorage.removeItem(key); // 删除无效数据
        return null;
    }
}

// 检查删除本地存储所有已过期数据
export function checkLocal() {
    const storageKeys = Object.keys(window.localStorage);
    storageKeys.forEach(key => {
        getLocal(key); // 获取数据方法，过期后会调用删除方法
    });
}